import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles"
import merge from "lodash-es/merge"
import PropTypes from "prop-types"
import { useMemo } from "react"

import { useSettingsContext } from "./SettingsContext"

ThemeContrast.propTypes = {
  children: PropTypes.node,
  disableMode: PropTypes.bool,
}

export default function ThemeContrast({ children, disableMode }) {
  const outerTheme = useTheme()

  const { themeContrast, themeMode } = useSettingsContext()

  const isLight = disableMode || themeMode === "light"

  const isContrastBold = true

  const themeOptions = useMemo(
    () => ({
      palette: {
        background: {
          ...(isContrastBold && {
            default: isLight ? outerTheme.palette.grey[100] : outerTheme.palette.grey[900],
          }),
        },
      },
      components: {
        MuiCard: {
          styleOverrides: {
            ...(isContrastBold && {
              root: {
                boxShadow: outerTheme.customShadows.z4,
              },
            }),
          },
        },
      },
    }),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isLight, themeContrast]
  )

  const theme = createTheme(merge(outerTheme, themeOptions))

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
